import { render, staticRenderFns } from "./TableBuscadorEmpleados.vue?vue&type=template&id=50aa167f"
import script from "./TableBuscadorEmpleados.vue?vue&type=script&lang=js"
export * from "./TableBuscadorEmpleados.vue?vue&type=script&lang=js"
import style0 from "./TableBuscadorEmpleados.vue?vue&type=style&index=0&id=50aa167f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports